<a *ngIf="link" [routerLink]="['/users', user.username]">
  <ng-container *ngTemplateOutlet="cardContent"></ng-container>
</a>
<ng-container *ngIf="!link">
  <ng-container *ngTemplateOutlet="cardContent"></ng-container>
</ng-container>

<ng-template #cardContent>
  <div class="user-card">
    <div class="image" id="card-image">
      <img [src]="icon" class="img" alt="User gravatar">
      <span *ngIf="gravatarInfo" tip="What is this?" tipPosition="top" (activate)="showGravatarModal($event)">
        <i class="fas fa-info-circle"></i>
      </span>
    </div>
    <div class="user-content">
      <div tabindex="0" class="title" id="card-title">{{user.name | titlecase}}</div>
      <div class="details">
        <div tabindex="0" class="username" id="card-username">
          Username: {{ user.username }}
        </div>
        <div tabindex="0" class="email" id="card-email">
          Email: {{user.email}}
        </div>
        <div tabindex="0" *ngIf="objects" class="learning-objects">
          Number of Learning Objects: {{objects.length}}
        </div>
      </div>
    </div>
  </div>
</ng-template>